module.exports = new __parcel__URL__("squad_confirm_button.44d29edf.png").toString();